import { render, staticRenderFns } from "./Bancos.vue?vue&type=template&id=571e7644&scoped=true"
import script from "./Bancos.vue?vue&type=script&lang=js"
export * from "./Bancos.vue?vue&type=script&lang=js"
import style0 from "./Bancos.vue?vue&type=style&index=0&id=571e7644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e7644",
  null
  
)

export default component.exports